import * as React from "react";
import styled from "styled-components";
import {Company} from "../../../../domain/model/company";

interface IProps {
    company: Company | null;
}

export const ClientBillingPlanMain: React.FC<IProps> = (props) => {
    const {company} = props;

    if (!company) {
        return <div/>;
    }

    let res: JSX.Element;

    res = (
        <React.Fragment>
            <Inner>
                {/* アドバイザー・コンサルティング */}
                <SectionTitle>アドバイザー・コンサルティング</SectionTitle>

                <PlanTable>
                    <PlanRow>
                        <PlanLabel>アカウント発行</PlanLabel>
                        <PlanValue>0円/月</PlanValue>
                    </PlanRow>
                    <PlanRow>
                        <PlanLabel>成約報酬</PlanLabel>
                        <PlanValue>90万円/件（税別）</PlanValue>
                    </PlanRow>
                    <PlanRow>
                        <PlanLabel>月額手数料 ※1</PlanLabel>
                        <PlanValue>10万円/件・月（税別）</PlanValue>
                    </PlanRow>
                    <PlanRow>
                        <PlanLabel>成約サポート ※2</PlanLabel>
                        <PlanValue>成約報酬 + 20万円/件（税別）</PlanValue>
                    </PlanRow>
                </PlanTable>

                <Notes>
                    <p>利用フォロー：営業時間内の電話、メールでのサービス利用フォロー、利用者向けの満足度調査の実施</p>
                    <p>※1 個人との契約期間中、発生する費用です。毎月稼働確認をさせて頂きます。</p>
                    <p>※2 人選/候補者との面談日程の調整並びに、面談同席、契約調整までフォロー致します。</p>
                </Notes>

                {/* メンタリング・リサーチ */}
                <SectionTitle>メンタリング・リサーチ（チケット制）</SectionTitle>

                <TicketPlans>
                    <TicketPlan>
                        <TicketLabel>単発プラン</TicketLabel>
                        <TicketValue>15万円/チケット（税別）</TicketValue>
                    </TicketPlan>
                    <TicketPlan>
                        <TicketLabel>複数回プラン</TicketLabel>
                        <TicketValue>140万円/10チケット（税別）</TicketValue>
                    </TicketPlan>
                </TicketPlans>

                <Notes>
                    <p>購入からの利用期間は半年間になります。</p>
                </Notes>

                {/* 研修 */}
                <SectionTitle>研修</SectionTitle>

                <PlanTable>
                    <PlanRow>
                        <PlanLabel>プラン</PlanLabel>
                        <PlanValue>応相談</PlanValue>
                    </PlanRow>
                </PlanTable>

                <Notes>
                    <p>料金は研修内容により変動するため、個別にご案内させて頂きます。</p>
                </Notes>
            </Inner>
        </React.Fragment>
    );

    return res;
};

export default ClientBillingPlanMain;

const Inner = styled.div`
    margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 30px;
    margin-top: 40px;
    color: #333;
`;

const PlanTable = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
`;

const PlanRow = styled.div`
    display: flex;
    margin-bottom: 2px;
`;

const PlanLabel = styled.div`
    background-color: #EAEBF7;
    padding: 15px 20px;
    font-size: 12px;
    font-weight: bold;
    color: #333;
    width: 140px;
    flex-shrink: 0;
`;

const PlanValue = styled.div`
    background-color: #fff;
    padding: 15px 20px;
    font-size: 15px;
    font-weight: normal;
    color: #333;
    flex: 1;
`;

const TicketPlans = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
`;

const TicketPlan = styled.div`
    display: flex;
    flex: 1;
`;

const TicketLabel = styled.div`
    background-color: #EAEBF7;
    padding: 15px 20px;
    font-size: 12px;
    font-weight: bold;
    color: #333;
    width: 140px;
    flex-shrink: 0;
`;

const TicketValue = styled.div`
    background-color: #fff;
    padding: 15px 20px;
    font-size: 15px;
    font-weight: normal;
    color: #333;
    flex: 1;
`;

const Notes = styled.div`
    margin-bottom: 30px;
    padding-left: 30px;

    p {
        font-size: 12px;
        line-height: 20px;
        color: #333;
        margin-bottom: 5px;
    }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/billing/client_billing_plan_main.tsx